import { Link } from '@tanstack/react-router';
import type { SourceMessageRef } from '@upme/contracts';
import { Badge } from '@upme/ui/components/badge';
import { Button } from '@upme/ui/components/button';
import { ExternalLink, MessageSquareText } from 'lucide-react';

interface Props {
  source: SourceMessageRef;
}

const dateFmt = new Intl.DateTimeFormat('ru-RU', {
  dateStyle: 'short',
  timeStyle: 'short',
});

export function EventSourceCard({ source }: Props) {
  return (
    <section className="rounded-lg border bg-card p-4 space-y-3">
      <header className="flex items-center gap-2">
        <MessageSquareText className="h-4 w-4 text-muted-foreground" aria-hidden />
        <h2 className="text-sm font-semibold">Источник</h2>
        <Badge variant="secondary">@{source.channelSlug}</Badge>
      </header>

      <dl className="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 text-sm">
        <dt className="text-muted-foreground">Канал</dt>
        <dd>
          <Link
            to="/source-channels/$channelId"
            params={{ channelId: source.channelId }}
            className="text-primary underline-offset-2 hover:underline"
          >
            {source.channelTitle}
          </Link>
        </dd>

        <dt className="text-muted-foreground">Сообщение</dt>
        <dd className="font-mono">#{source.telegramMessageId}</dd>

        <dt className="text-muted-foreground">Опубликовано</dt>
        <dd className="tabular-nums">{dateFmt.format(new Date(source.postedAt))}</dd>
      </dl>

      <Button asChild size="sm" variant="outline">
        <a href={source.postUrl} target="_blank" rel="noreferrer noopener">
          <ExternalLink className="h-4 w-4" aria-hidden />
          Открыть в Telegram
        </a>
      </Button>
    </section>
  );
}
